class QuotesSection extends BTSection {
  onInit() {
    if(!Shopify.designMode) {
      var timeout = BT.data.cacheWindowWidth < BT.options.windowScreen.desktop ? 2300 : 1800;
      setTimeout(() => {
        BT.initSlider(this.container, true);
      }, timeout);
    } else {
      BT.initSlider(this.container, true);
    }
    this.slider = this.container.find(BT.getSliderSelector());
  }


  onBlockSelect(evt) {
    var ele = $(evt.target);
    if(ele.attr('data-slick-index') != undefined) {
      if(!ele.hasClass('slick-current')) {
        this.slider.slick('slickGoTo', ele.attr('data-slick-index'), true);
      }
      this.slider.slick('slickPause');
    }
  }
  onBlockDeselect() {
    // Resume auto-rotate
    if(this.slider.hasClass('slick-initialized')) {
      this.slider.slick('slickPlay');
    }
  }
  onUnload() {
    BT.destroySlider(this.container);
  }
}
theme.sections.constructors['quotes'] = QuotesSection;